import _styled from "styled-components";
import React, { useCallback, useMemo } from 'react';
import Select from 'react-select';
import * as styles from './MultiSelect.style';
export const MultiSelect = _ref => {
  let {
    id,
    dataRef,
    name,
    value,
    options,
    'aria-label': ariaLabel,
    required,
    disabled,
    placeholder,
    error,
    onChange,
    onBlur
  } = _ref;
  const internalOptions = useMemo(() => options.map(option => ({
    ...option,
    isDisabled: option.disabled
  })), [options]);
  const internalValue = useMemo(() => value ? internalOptions.filter(option => value.indexOf(option.value) >= 0) : [], [value, internalOptions]);
  const onInternalChange = useCallback(values => {
    const customEvent = {
      target: {
        name,
        value: values.map(option => option.value)
      }
    };
    if (onChange) {
      onChange(customEvent);
    }
  }, [name, onChange]);
  const onInternalBlur = useCallback(event => {
    if (onBlur) {
      onBlur(event);
    }
  }, [onBlur]);
  return /*#__PURE__*/React.createElement(_StyledSelect, {
    "data-ref": dataRef,
    $error: error,
    id: id,
    name: name,
    isMulti: true,
    isDisabled: disabled,
    required: required,
    value: internalValue,
    "aria-label": ariaLabel,
    onChange: onInternalChange,
    options: internalOptions,
    placeholder: placeholder || 'Seleziona...',
    classNamePrefix: "multi-select",
    onBlur: onInternalBlur,
    $_css: styles.container
  });
};
export default MultiSelect;
var _StyledSelect = _styled(Select).withConfig({
  displayName: "MultiSelect___StyledSelect",
  componentId: "sc-hiac4z-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=MultiSelect.js.map